/// <reference path="../objects/classes/basecontroller.ts" />
/// <reference path="../services/composition.service.ts" />
/// <reference path="../objects/interfaces/iproduct.ts" />
/// <reference path="../objects/interfaces/icategorygroup.ts" />

module App.Controllers
{
    import ICategoryGroup = Interfaces.ICategoryGroup

    export interface IProductsController extends IBaseController
    {

    }

    export class ProductsController extends BaseController implements IProductsController, Interfaces.IStepController
    {
        static controllerId = 'productsController';

        static $inject = [
            '$rootScope',
            '$scope',
            '$q',
            Services.SessionService.serviceId,
            Services.NavigationService.serviceId,
            Services.CompositionService.serviceId,
            SnackbarFactory.factoryId,
            '$location',
            'ngDialog',
            '$sce',
            Services.ValidationService.serviceId,
            Services.AccountService.serviceId
        ];

        products: Interfaces.IProduct[]
        selectedProducts: Interfaces.IProduct[]
        reminderSeen: boolean = false;
        reminderProduct: Interfaces.IProduct
        productGroupSubGroups: ICategoryGroup[] = [];
        stepName: string = Constants.routeKeys.products;
        noDesiredProducText: string = ""

        constructor($rootScope: Interfaces.IAppRootScope,
            $scope: ng.IScope,
            $q: ng.IQService,
            sessionService: App.Interfaces.ISessionService,
            navigationService: App.Interfaces.INavigationService,
            composition: Interfaces.ICompositionService,
            public snackbarFactory: Interfaces.ISnackbarFactory,
            private $location: ng.ILocationService,
            ngDialog: any,
            $sce: any,
            validationService: Interfaces.IValidationService,
            accountService: Interfaces.IAccountService)
        {
            super($rootScope, $scope, $q, sessionService, navigationService, composition, ngDialog, $sce, validationService, accountService, snackbarFactory)

            window.pageLoadDatalayerEvent(datalayerPageEvents.stap2)
            this.noDesiredProducText = App.Variables.noDesiredProducText
            this.loadProducts()
            this.addUrlCodesToBasket()

            this.$scope.$on(Constants.broadcast.shopcartUpdatedFromCart,
                () =>
                {
                    this.loadProducts()
                    this.checkPageValidation()
                })

            this.checkPageValidation()
        }

        loadProducts = () =>
        {
            if (this.sessionService.composition != null) {
                if (this.sessionService.composition.products != null)
                    this.products = this.sessionService.composition.products.filter((d) => {
                        let productName = d.name.toLowerCase()

                        return productName.indexOf(Constants.waitForSearchPhrase) < 0
                    })

                if (this.products == null) {
                    this.goToStep(Constants.routeKeys.cardetail)
                    return
                }

                let sortedGroups = []

                if (this.sessionService.composition.categoryHelpDescriptions != null) {
                    sortedGroups = this.sessionService.composition.categoryHelpDescriptions.sort((a, b) => { return a.newcategorySort - b.newcategorySort })
                }

                sortedGroups.push({
                    category: '',
                    description: '',
                    newcategorySort: 999
                })

                for (var k = 0; k < sortedGroups.length; k++) {
                    var productGroup = this.productGroupSubGroups.filter(x => x.name == sortedGroups[k].category)

                    if (productGroup == null || productGroup.length == 0) {
                        this.productGroupSubGroups.push({
                            sort: sortedGroups[k].newcategorySort,
                            name: sortedGroups[k].category,
                            description: sortedGroups[k].description,
                            subcategories: []
                        })
                    }
                }


                for (var j = 0; j < this.products.length; j++) {
                    var productGroup = this.productGroupSubGroups.filter(x => x.name.toLowerCase() == this.products[j].category.toLowerCase())

                    if (productGroup == null || productGroup.length == 0)
                        continue

                    var subCategory = this.products[j].subCategory

                    if (productGroup[0].subcategories == null || productGroup[0].subcategories.length == 0)
                        productGroup[0].subcategories = ['']

                    if (productGroup[0].subcategories.filter(x => x == subCategory).length == 0)
                        productGroup[0].subcategories.unshift(subCategory)
                }

                this.productGroupSubGroups = this.productGroupSubGroups.sort((a, b) => { return a.sort - b.sort })

                if (this.sessionService.composition.selectedProducts != null) {
                    this.selectedProducts = this.sessionService.composition.selectedProducts

                    //set selected description for products
                    for (var i = 0; i < this.selectedProducts.length; i++) {
                        var selectedProduct = this.selectedProducts[i]

                        var product = this.products.filter((p) => { return p.name == selectedProduct.name })
                        if (product.length > 0) {
                            product[0].productExtraTextField = selectedProduct.productExtraTextField
                            product[0].showProductTextField = selectedProduct.showProductTextField
                        }
                    }
                } else {
                    this.selectedProducts = []
                }
            } else {
                this.selectedProducts = []
            }

            window.sendAddProductToDatalayer('view_item_list', this.sessionService.composition.products, window.getBrand(this.sessionService), this.sessionService?.composition?.mileage)
        }

        addUrlCodesToBasket = () =>
        {
            //set products from url
            if (App.Variables.workcode != '')
            {
                var codes = App.Variables.workcode.split(',')
                for (var i = 0; i < codes.length; i++)
                {
                    if (!codes[i])
                        continue
                    var product = this.products.filter((p) => { return p.name.toLowerCase() == codes[i].toLowerCase() })

                    if (product != null && product.length > 0 && !this.isSelected(product[0]))
                    {
                        this.addToBasket(product[0])
                    }
                }
            }
        }

        maintenanceProducts = () =>
        {
            if (this.products == null) return []

            return this.products.filter((p) => { return p.type == Constants.productTypes.maintenance })
        }

        getGroupName = (productGroupName) =>
        {
            if (productGroupName == '')
                return Constants.emptyGroupName

            return productGroupName
        }

        getGroupDescription = (productGroupName) =>
        {
            if (productGroupName == '' || this.sessionService.composition.categoryHelpDescriptions == null)
                return ''


            var catDesc = this.sessionService.composition.categoryHelpDescriptions.filter(x => x.category.toLowerCase() == productGroupName.toLowerCase())
            var desc = ''
            if (catDesc != null && catDesc.length > 0)
                desc = catDesc[0].description

            return desc
        }

        actionsProducts = (category) =>
        {
            if (this.products == null) return []

            return this.products.filter((p) =>
            {
                return p.category.toLowerCase() == category.toLowerCase()
            })
        }

        actionsProductsWithSubGroup = (category, subgroup) =>
        {
            if (this.products == null) {
                return []
            }

            return this.products.filter((p) =>
            {
                if (subgroup != '')
                {
                    return p.category.toLowerCase() == category.toLowerCase() && p.subCategory.toLowerCase() == subgroup.toLowerCase()
                } else
                {
                    return p.category.toLowerCase() == category.toLowerCase() && p.subCategory == ''
                }

            })
        }

        categoryHasProducts = (categoryName) =>
        {
            if (this.products == null) return false

            return this.products.filter((p) =>
            {
                if (categoryName != '')
                {
                    return p.category.toLowerCase() == categoryName.toLowerCase()
                }
            }).length > 0
        }


        addToBasket = (product) =>
        {
            if (this.selectedProducts.filter((p) => { return p.name == product.name }).length <= 0)
            {
                this.selectedProducts.push(product)
                window.sendAddProductToDatalayer('select_item', this.sessionService.composition.selectedProducts, window.getBrand(this.sessionService), this.sessionService?.composition?.mileage)
            } else
            {
                this.removeFromBasket(product)
            }

            if (this.selectedProducts.length > 0) {
                this.sendProductStatus()
            }
        }        

        addToBasketAndContinue = (product) =>
        {
            this.addToBasket(product)
            this.isValid()
        }

        groupShopcartCount = (productGroupName) =>
        {
            if (this.products == null) return 0

            return this.selectedProducts.filter((p) =>
            {
                return p.groupName == productGroupName && p.type != Constants.productTypes.maintenance
            }).length
        }

        groupProductCount = (productGroupName) =>
        {
            return this.actionsProducts(productGroupName).length
        }


        removeFromBasket = (product) =>
        {
            var products = this.selectedProducts.filter((p) => { return p.name == product.name })

            if (products.length > 0)
            {
                var index = this.selectedProducts.indexOf(products[0])
                var data = angular.copy(this.selectedProducts)
                data.splice(index, 1)
                this.selectedProducts = data

                this.sessionService.composition.selectedProducts = this.selectedProducts

                this.sendProductStatus()
            }
        }

        isSelected = (product) =>
        {
            return this.selectedProducts.filter((p) =>
            {
                return p.name == product.name
            }).length >
                0
        }

        isValid(isLogicCheck: boolean = false): boolean
        {
            if (!this.reminderSeen && this.reminderProduct != null) {
                this.showReminder()
                return false
            } else {
                this.reminderProduct = null
            }

            if (this.selectedProducts.length > 0)
            {
                let noCommentProducts = this.selectedProducts.filter(x => x.question != null && (x.productExtraTextField == null || x.productExtraTextField == ''))

                if (noCommentProducts.length > 0)
                {
                    this.snackbarFactory.show(`U moet een opmerking voor de ${noCommentProducts[0].name.toLowerCase()} plaatsen`, 4000)
                    return false
                }

                this.sendProductStatus()

                if (!isLogicCheck) {
                    window.sendAddProductToDatalayer('add_to_cart', this.sessionService.composition.selectedProducts, window.getBrand(this.sessionService), this.sessionService?.composition?.mileage)
                }

                return true
            }
            else
            {
                if (!isLogicCheck)
                {
                    this.snackbarFactory.show('U moet minimaal 1 product kiezen.', 4000)
                }
                return false
            }
        }

        sendProductStatus = () =>
        {
            var composition = this.sessionService.composition
            composition.selectedProducts = this.selectedProducts

            composition.selectedReplacementVehicle = null
            composition.waitForJob = null
            composition.requiresReplacementVehicle = null
            composition.selectedReplacementVehicle = null
            composition.storeSelected = false
            composition.selectedDate = null
            composition.selectedTime = null
            composition.allAllowedStores = null

            this.sessionService.composition = composition
            this.$scope.$emit(Constants.broadcast.compositionChange)
        }

        goBackToStep()
        {
            this.goToStep(Constants.routeKeys.cardetail)
        }

        base = (txt) =>
        {
            if (txt != null)
                return atob(txt)
            return ''
        }

        encode = (txt) =>
        {
            if (txt != null)
                return encodeURI(txt)
            return ''
        }

        showReminder()
        {
            this.reminderSeen = true

            var reminderProducts = this.products.filter((p) =>
            {
                return p.isReminderProduct
            })

            if (reminderProducts.length > 0 && !this.isSelected(reminderProducts[0]))
            {
                this.reminderProduct = reminderProducts[0]
            } else
            {
                this.isValid()
            }
        }

        productHasPrice = (product: Interfaces.IProduct) =>
        {
            return product.price > 0 || product.discountPrice > 0
        }

        getPrice = (product: Interfaces.IProduct) =>
        {
            if (product.discountPrice > 0 && (product.discountPrice < product.price || product.price == 0))
                return product.discountPrice

            if (product.price == null)
                return ''

            if (product.price % 1 != 0)
                return product.price.toLocaleString('nl-nl', { minimumFractionDigits: 2 })
            else
                return product.price
        }

        disableClick = (event) =>
        {
            event.stopPropagation()
        }

        updateBasketProduct = (product) =>
        {
            var selectedProduct = this.selectedProducts.filter((p) => { return p.name == product.name })
            if (selectedProduct.length > 0)
            {
                selectedProduct[0].productExtraTextField = product.productExtraTextField
                selectedProduct[0].showProductTextField = product.showProductTextField
            }

            this.sendProductStatus()
        }

        scrollTop = () =>
        {
            window.scrollTo(0, 0)
        }

        hasDiscountPrice = (product: Interfaces.IProduct) =>
        {
            return product.discountPrice != null && product.discountPrice > 0
        }
    }

    app.controller(ProductsController.controllerId, ProductsController)
}